//App configuration goes here
const config = {
  //*******Production URL******//
  apiEndpoint: "https://be.bookingjini.com/",
  beAlphaEndpoint: "https://be-alpha.bookingjini.com/",
  public_image_url:
    "https://s3.ap-south-1.amazonaws.com/images.bookingjini.com/bookingEngine/",
  kEndpoint: "https://kernel.bookingjini.com/",
  gemsApiEndPoint: "https://gems.bookingjini.com/api/",
  baseUrl: "/",
};
export default config;
